import React from "react";
import Image from "react-bootstrap/esm/Image";
import { default as config } from "../config.json";
import { turkishCurrencyFormatterNoPrecision } from "../utils";
import MenuIcon from "./MenuIcon";
import MessageBox from "./MessageBox";

export default function ProductsList(props) {
  const { products, setFeature, setFeatures, setProduct, isTabletOrMobile } =
    props;

  return (
    <div
      className="bg-white scrollbar scrollbar-primary p-2"
      style={{ overflowY: "auto", height: "100%" }}
    >
      {products.length > 0 ? (
        <div>
          {products.map((p, index) => (
            <div
              key={
                p._id +
                (p.features && p.features.length === 1 ? p.features[0]._id : "")
              }
              className={`product-list-item d-flex align-items-center ${
                index !== products.length - 1 ? "border-bottom" : ""
              }`}
              onClick={() => {
                if (p.features.length === 1) {
                  setFeatures(p.features);
                  setProduct(p);
                  setFeature(p.features[0]);
                } else {
                  setFeatures(p.features);
                  setProduct(p);
                }
              }}
            >
              <Image
                className="small-product-list-image border border-secondary me-3"
                src={p.image || config.default_image}
                alt={p.name}
                fluid
                rounded
              />
              <div className="flex-grow-1 text-start">
                <h5 className="mb-1">
                  {p.features && p.features.length === 1 ? (
                    <>
                      <span className="text-danger">{p.features[0].name} </span>
                      <span>{p.name}</span>
                    </>
                  ) : (
                    <span>{p.name}</span>
                  )}{" "}
                  {p.no && (
                    <span className="text-muted small-font">No {p.no}</span>
                  )}
                </h5>
                <span className="text-muted">
                  {turkishCurrencyFormatterNoPrecision(
                    p.price > 0
                      ? p.price.toFixed(2)
                      : p.features.length > 0
                      ? p.features[0].price.toFixed(2)
                      : 0
                  )}
                </span>
              </div>
              {p.questions?.length > 0 && false && <MenuIcon />}
            </div>
          ))}
        </div>
      ) : (
        <div className={isTabletOrMobile ? "p-2 mt-3" : "p-1 mt-1"}>
          <MessageBox variant="danger">Ürün bulunamadı!</MessageBox>
        </div>
      )}
      <style>
        {`
          .product-list-item {
            cursor: pointer;
            padding: 10px 0;
            transition: background-color 0.3s ease, transform 0.2s ease;
            margin-left: 10px;
            position: relative;
          }
          .product-list-item:hover {
            background-color: #e9f7fa; /* Soft light blue for hover */
            transform: scale(1.02);
          }
          .product-list-item:active {
            background-color: #d1ecf1; /* Slightly darker blue for active */
            transform: scale(1);
          }
          .product-list-item.border-bottom {
            border-bottom: 1px solid #dee2e6; /* Light gray line between items */
          }
          .small-product-list-image {
            width: 50px;
            height: auto;
          }
        `}
      </style>
    </div>
  );
}
